module.exports = __webpack_public_path__ + "6fec5e03f29f825863c47e2b6d9ca743.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_l_50.mp3
// module id = 442
// module chunks = 0